/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";